import React, { useEffect, useState } from "react";
import { useServiceTypes } from "../../hooks";
import { Tag } from "antd";

const OrderServiceType = (props) => {
  const { record } = props;
  const [name, setName] = useState(null);
  const serviceTypes = useServiceTypes();

  useEffect(() => {
    const selected = serviceTypes
      ? serviceTypes.filter((item) => item.id === record.service_type)[0]
      : null;
    if (selected) {
      setName(selected["name"]);
    }
  }, [serviceTypes, record.service_type]);

  return (
    <Tag color={name === "זכאות שבועית" ? "cyan" : "blue"}>
      {name ? name : ""}
    </Tag>
  );
};

export default OrderServiceType;
